import app from './app';
import utils from './utils.js';
import FileSaver  from 'file-saver';
import {changeDpiBlob} from './changedpi.js'
import EXIF from 'exif-js'

/**
 * 导出图片
 */
export default {
    isSaved: false,
    save: function(canvas) {

        let name = app.uploadFile.file.name
        console.log(name)

        let suffix = app.uploadFile.file.type
        if (app.uploadFile.file.type == 'image/x-ms-bmp') {
            suffix = 'image/bmp'
        }
        
        // if (!utils.browserIsPc()) {
        //     $('.mobile-save-image').css('display', 'flex')
        //     $('.image-show-box img').attr('src', canvas.toDataURL(suffix))
        //     return false
        // }

        canvas.toBlob(function (blob) {
            EXIF.getData(app.uploadFile_old,function(){
                var dpi=96
                if(EXIF.getAllTags(this).XResolution){
                    dpi=EXIF.getAllTags(this).XResolution.numerator/EXIF.getAllTags(this).XResolution.denominator
                }
                changeDpiBlob(blob, dpi).then(function(blob){
                    var url = URL.createObjectURL(blob)
                    console.log(blob)
                    if (window.navigator.msSaveBlob) {
                        try {
                          window.navigator.msSaveBlob(blob, name)
                        } catch (e) {
                        }
                    } else {
                        FileSaver.saveAs(blob, name);
                    }
                    URL.revokeObjectURL(url)
                })
            })
        }, app.uploadFile.file.type)
    },

    /**
     * 获取图片导出名
     */
    getName: function () {
        let arr = app.file.name.split('.')
        let realName = filename.replace('.'+arr[arr.length-1], '')
        return realName
    },
    getSuffix: function() {
        let arr = app.file.name.split('.')
        let suffix = arr[arr.length-1]
        return suffix
    }
}
